import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PaymentsFacade } from './+state';
import { PaymentsStateModule } from './+state/payments.state.module';
import { PaymentsService } from './services';

@NgModule({
  imports: [CommonModule, PaymentsStateModule],
})
export class DomainPaymentsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainPaymentsModule,
      providers: [PaymentsService, PaymentsFacade],
    };
  }
}
